import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Images } from 'utils';

/**
 * One draggable goal row in the Session Preparation list. The whole row is the
 * sortable node, but only the grip handle carries the drag listeners so the
 * checkbox / pin / goal-link controls stay clickable.
 */
export const SortableGoalRow = ({ id, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        // Dim the source row into a placeholder while its clone floats in the DragOverlay.
        opacity: isDragging ? 0.4 : 1,
        position: 'relative',
    };

    return (
        <div ref={setNodeRef} style={style} className={`session-goal-row ${isDragging ? 'is-dragging' : ''}`} {...attributes}>
            <button type="button" className="goal-drag-handle" aria-label="Drag to reorder" {...listeners}>
                <img src={Images.dragIcon} alt="drag" />
            </button>
            {children}
        </div>
    );
};
